import axios from 'axios';

export default {
    getProductById({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/umbraco/api/product/getproductbyumbracoid?id=${id}`)
                .then(function(response) {
                    console.log(response);
                    const data = {
                        id: id,
                        name: response.data.Name,
                        description: response.data.Description,
                        productImageSource: response.data.Images,
                        isConfigurable: response.data.IsConfigurable,
                        brochure: response.data.Brochure,
                        productUrl: response.data.ProductUrl,
                        implementations: response.data.Implementation,
                        options: response.data.Options
                    };

                    commit('setProduct', data);
                    resolve();
                })
                .catch(function(error) {
                    reject(error);
                });
        });
    },
    setLanguage(context, payloadLocale) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/umbraco/api/translations/GetAllTranslations?locale=${payloadLocale}`)
                .then(response => {
                    context.commit('setLanguage', { locale: payloadLocale, translations: response.data });
                    resolve();
                })
                .catch(e => {
                    console.log('Something went wrong retrieving translations for locale!', e);
                    reject(e);
                });
        });
    },
    setTranslationForKey(context, payload) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/umbraco/api/translations/GetSingleTranslation?locale=${payload.locale}&key=${payload.key}`)
                .then(response => {
                    if (response.data) {
                        context.commit('setTranslation', { locale: payload.locale, key: payload.key, value: response.data });
                    }
                    resolve();
                })
                .catch(e => {
                    console.log('Something went wrong retrieving translation value!', e);
                    reject(e);
                });
        });
    }
};
